import { TextValidationResult } from "@/types/text-validation-result";

/**
 * Extracts a named property from XML content.
 * @param xml The xml content.
 * @param propertyName The name of the property to extract.
 */
export function extractPropertyFromXml(xml: string = "", propertyName: string): string {
	const xmlToLower = xml.toLowerCase();
	const propertyNameToLower = propertyName.toLowerCase();

	const propertyStartTag = `<${propertyNameToLower}>`;
	const propertyEndTag = `</${propertyNameToLower}>`;

	return xml.substring(
		xmlToLower.indexOf(propertyStartTag) + propertyStartTag.length,
		xmlToLower.indexOf(propertyEndTag)
	);
}

/**
 * Extracts a named property from XML content - return "" if not found
 * @param xml The xml content.
 * @param propertyName The name of the property to extract.
 */
export function extractPropertyFromXmlWithContainsCheck(xml: string = "", propertyName: string): string {
	const xmlToLower = xml.toLowerCase();
	const propertyNameToLower = propertyName.toLowerCase();
	if (xmlToLower.includes(propertyNameToLower)) {
		const propertyStartTag = `<${propertyNameToLower}>`;
		const propertyEndTag = `</${propertyNameToLower}>`;
		return xml.substring(
			xmlToLower.indexOf(propertyStartTag) + propertyStartTag.length,
			xmlToLower.indexOf(propertyEndTag)
		);
	}
	return "";
}

/**
 * Confirms if the provided input is a valid regex pattern.
 * Return the valid status and an error message if invalid.
 * @param input The regex pattern to check
 */
export function isRegexValid(input: string): TextValidationResult {
	try {
		new RegExp(input);
		return { isValid: true, message: "" };
	} catch {
		return { isValid: false, message: "Provided regex is invalid" };
	}
}

/**
 * Converts a full name into its initials.
 * @param name The full name to convert.
 */
export function nameToInitials(name: string): string {
	if (!name) {
		return "";
	}
	const words = name.split(" ");
	const initials = words.map(word => word.charAt(0).toUpperCase());

	return initials.join("");
}

/**
 * Repeats a string a specified number of times.
 * @param str The string to repeat
 * @param count The number of times to repeat the string
 * @returns A string repeated count times, or the original string if count is negative or infinite
 */
export function safeRepeat(str: string, count: number): string {
	if (count <= 0 || count === Infinity) {
		return "";
	}

	return Array(count + 1).join(str);
}